import React from 'react';
import ButtonBase from './ButtonBase';
import PropTypes from 'prop-types';

const NewSecondary = ({
  type = 'button',
  onClick,
  children,
  disabled,
  size,
  height = 'auto',
  loading,
  iconStart,
  iconEnd,
  tag,
  href,
  download,
  target,
  alt,
  fontSize = 'text',
  buttonDesign = 'secondary',
  hover,
  variant,
  ...restProps
}) => {
  const availableColors = {
    black: { defaultColor: 'default', hoverColor: '_xlightGray' },
    green: { defaultColor: 'primary', hoverColor: '_xlightGray' },
    purple: { defaultColor: '_lightPurple', hoverColor: 'lightPurple' },
    link: { defaultColor: 'link', hoverColor: '_xlightGray' },
    gray: { defaultColor: 'lightWhite', hoverColor: '_xlightGray' },
  };
  const colorVariant = availableColors[variant] || availableColors['black'];
  return (
    <ButtonBase
      type={type}
      onClick={onClick}
      disabled={disabled}
      size={size}
      height={height}
      loading={loading}
      iconStart={iconStart}
      iconEnd={iconEnd}
      backgroundColor="white"
      borderColor={colorVariant.defaultColor}
      color={colorVariant.defaultColor}
      tag={tag}
      href={href}
      download={download}
      target={target}
      alt={alt}
      fontSize={fontSize}
      borderWidth="1px"
      buttonDesign={buttonDesign}
      hover={{
        backgroundColor: colorVariant.hoverColor,
      }}
      {...restProps}
    >
      {children}
    </ButtonBase>
  );
};

NewSecondary.propTypes = {
  type: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  size: PropTypes.string,
  loading: PropTypes.bool,
  iconStart: PropTypes.node,
  iconEnd: PropTypes.node,
  tag: PropTypes.string,
  href: PropTypes.string,
  download: PropTypes.bool,
  target: PropTypes.string,
  alt: PropTypes.string,
  fontSize: PropTypes.string,
  hover: PropTypes.object,
  buttonDesign: PropTypes.string,
  variant: PropTypes.string,
  height: PropTypes.string,
};

export default NewSecondary;
